import type { HbBidderConfig } from '../types'

const DISPLAY_PLACEMENT_ID = 91799
const VIDEO_PLACEMENT_ID = 91800

export const ADITUDE_DISPLAY: HbBidderConfig = {
    bidder: 'cpmstar',
    params: {
        placementId: DISPLAY_PLACEMENT_ID,
    },
}

export const ADITUDE_VIDEO: HbBidderConfig = {
    bidder: 'cpmstar',
    params: {
        placementId: VIDEO_PLACEMENT_ID,
    },
}
